import "./style.css";

export default function ServicesProvided() {
  const Alisamentos = [
    { id: 1, name: "Orgânicos" },
    { id: 2, name: "Formol" },
    { id: 3, name: "Ácidos" },
  ];

  const Tratamentos = [
    { id: 1, name: "Botox" },
    { id: 2, name: "Banho Nutrição" },
    { id: 3, name: "Banho Reconstrução" },
    { id: 4, name: "Hidratação" },
    { id: 5, name: "Ritual Lua Crescente" },
  ];

  const Estilizacao = [
    { id: 1, name: "Escova" },
    { id: 2, name: "Escova de Uva" },
    { id: 3, name: "Cortes" },
    { id: 4, name: "Combo Mechas" },
  ];

  const Estetica = [
    { id: 1, name: "Sobrancelhas" },
    { id: 2, name: "Depilação" },
  ];

  return (
    <div className='services-container' id="ServicesProvided">
      <div className='services-title'>
        <h2>Quais nossos serviços?</h2>
      </div>
      <div className="services-list-container">
        <div className="services-list">
          <h3 className="services-list-title">
            Estilizacao
          </h3>
          {Estilizacao.map((x) => (
            <div className="services-item" key={x.id}>
              <h3 className="services-item-name">- {x.name}</h3>
            </div>
          ))}
        </div>
        <div className="services-list">
          <h3 className="services-list-title">
            Tratamentos
          </h3>
          {Tratamentos.map((x) => (
            <div className="services-item" key={x.id}>
              <h3 className="services-item-name">- {x.name}</h3>
            </div>
          ))}
        </div>
        <div className="services-list">
          <h3 className="services-list-title">
            Alisamentos
          </h3>
          {Alisamentos.map((x) => (
            <div className="services-item" key={x.id}>
              <h3 className="services-item-name">- {x.name}</h3>
            </div>
          ))}
        </div>
        <div className="services-list">
          <h3 className="services-list-title">
            Estética
          </h3>
          {Estetica.map((x) => (
            <div className="services-item" key={x.id}>
              <h3 className="services-item-name">- {x.name}</h3>
            </div>
          ))}
        </div>
        <div className="services-cta">
          <a href="https://wa.me/554284093699" target="_blank" rel="noreferrer">
            <button>Agendar agora</button>
          </a>
        </div>
      </div>
    </div>
  );
};